import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ORGANISATIONS_FEATURE_KEY, organisationsAdapter, OrganisationsState,} from './organisations.reducer';


// Lookup the 'Organisations' feature state managed by NgRx
export const selectOrganisationsState =
    createFeatureSelector<OrganisationsState>(ORGANISATIONS_FEATURE_KEY);

const {selectAll, selectEntities} = organisationsAdapter.getSelectors();


export const selectAllOrganisations = createSelector(
    selectOrganisationsState,
    (state: OrganisationsState) => selectAll(state)
);

export const selectOrganisationsEntities = createSelector(
    selectOrganisationsState,
    (state: OrganisationsState) => selectEntities(state)
);

export const selectSelectedId = createSelector(
    selectOrganisationsState,
    (state: OrganisationsState) => state.selectedId
);

export const selectEntity = createSelector(
    selectOrganisationsEntities,
    selectSelectedId,
    (entities, selectedId) => (selectedId ? entities[selectedId] : undefined)
);


